import useLangStore from '../stores/langStore';
import translations from '../i18n';
export default function useLang() {
  const { lang, setLang } = useLangStore();
  return { T: translations[lang], lang, setLang };
}
